const Disclaimer = () => (
    <div className="disclaimer bg-[#F5F5F5] gap-6">
        <h2 className="text-base font-bold text-center">
            BEWARE OF SPURIOUS PHONE CALLS AND FICTITIOUS OFFERS.
        </h2>
        <p className="text-xs text-center mt-2">
            Do not fall prey to unknown calls or messages promising benefits for porting your
            policy or offering attractive premium discounts for making payment to unidentified
            Bank A/Cs.
        </p>
        <p className="text-xs text-center mt-2">
            IRDAI is not involved in activities like selling insurance policies, announcing bonus
            or investment of premiums.
        </p>
        <p className="text-xs text-center mt-2">
            Public receiving such phone calls are requested to lodge a police complaint and report
            the incident to the Company.
        </p>
    </div>
);

export default Disclaimer;
